import { z } from 'zod';

import { zodBlockerSchema } from '~/data/company/validations';

export const zodCompanyAccountDeletionCheckResponseSchema = z.object({
  blockers: z.array(zodBlockerSchema),
  deletable: z.boolean(),
});
